import React from 'react';
import { FormattedMessage } from 'react-intl';

import PropTypes from 'prop-types';

import {
    Button,
    CircularProgress,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
} from '@material-ui/core';

import LocaleMessage from '~/components/LocaleMessage';

import { getMapPointSelectionKey } from '../../lib/robotDeliveryPayload';
import { DarkDialog } from '../../styles';
import { containedMissionPointButtonSx } from './rc3MissionUiConstants';

export default function Rc3DeliveryConfirmDialog({
    open,
    onClose,
    selectedPoses,
    onConfirm,
    titleMsg,
    bodyIntroMsgId,
    bodyIntroDefaultMessage,
    cancelMsg,
    confirmMsg,
    submitting,
}) {
    const list = Array.isArray(selectedPoses) ? selectedPoses : [];

    return (
        <Dialog
            open={open}
            onClose={submitting ? undefined : onClose}
            maxWidth="sm"
            fullWidth
            scroll="paper"
        >
            <DarkDialog>
                <DialogTitle
                    style={{
                        textTransform: 'uppercase',
                        width: '100%',
                        boxSizing: 'border-box',
                        wordBreak: 'break-word',
                    }}
                >
                    <LocaleMessage msg={titleMsg} />
                </DialogTitle>
                <DialogContent
                    style={{
                        width: '100%',
                        boxSizing: 'border-box',
                        paddingTop: 12,
                    }}
                >
                    {list.length ? (
                        <div
                            style={{
                                color: '#fff',
                                fontSize: '1rem',
                                lineHeight: 1.5,
                                wordBreak: 'break-word',
                                overflowWrap: 'break-word',
                                width: '100%',
                            }}
                        >
                            <FormattedMessage
                                id={bodyIntroMsgId}
                                defaultMessage={bodyIntroDefaultMessage}
                                values={{ count: list.length }}
                            />
                            <ol
                                style={{
                                    margin: '12px 0 0',
                                    paddingLeft: 22,
                                    color: '#e3f2fd',
                                }}
                            >
                                {list.map(pose => (
                                    <li
                                        key={getMapPointSelectionKey(pose)}
                                        style={{ marginBottom: 6 }}
                                    >
                                        {pose.name}
                                    </li>
                                ))}
                            </ol>
                        </div>
                    ) : null}
                </DialogContent>
                <DialogActions
                    style={{
                        flexWrap: 'wrap',
                        justifyContent: 'flex-end',
                        gap: 8,
                        padding: '12px 16px 16px',
                        width: '100%',
                        boxSizing: 'border-box',
                    }}
                >
                    <Button
                        onClick={onClose}
                        color="primary"
                        disabled={submitting}
                    >
                        <LocaleMessage msg={cancelMsg} />
                    </Button>
                    <Button
                        onClick={onConfirm}
                        color="primary"
                        variant="contained"
                        disabled={submitting || !list.length}
                        style={{
                            ...containedMissionPointButtonSx,
                            minWidth: 140,
                        }}
                    >
                        {submitting ? (
                            <CircularProgress size={22} color="inherit" />
                        ) : (
                            <LocaleMessage msg={confirmMsg} />
                        )}
                    </Button>
                </DialogActions>
            </DarkDialog>
        </Dialog>
    );
}

Rc3DeliveryConfirmDialog.propTypes = {
    open: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    selectedPoses: PropTypes.arrayOf(
        PropTypes.shape({ name: PropTypes.string })
    ),
    onConfirm: PropTypes.func.isRequired,
    titleMsg: PropTypes.string.isRequired,
    bodyIntroMsgId: PropTypes.string.isRequired,
    bodyIntroDefaultMessage: PropTypes.string.isRequired,
    cancelMsg: PropTypes.string,
    confirmMsg: PropTypes.string,
    submitting: PropTypes.bool,
};

Rc3DeliveryConfirmDialog.defaultProps = {
    selectedPoses: [],
    cancelMsg: 'button.cancel',
    confirmMsg: 'rc3.robot.data.delivery.confirm.cta',
    submitting: false,
};
